module.exports = __webpack_public_path__ + "media/images/rank_02-6f2f874b36198e4305d5385106496c86.png";